import Error from '../model/Error';

export default class EventDispatcher {

	static loadingAction(type) {
		return type + "_LOADING";
	}

	static successAction(type) {
		return type + "_FULFILLED";
	}

	static errorAction(type) {
		return type + "_REJECTED";
	}

	static fatalAction(type) {
		return type + "_FATAL";
	}

	static loading(dispatch, type) {
		dispatch({type: EventDispatcher.loadingAction(type)});
	}

	static success(dispatch, type, data) {
		dispatch({type: EventDispatcher.successAction(type), data: data});
	}

	static error(dispatch, type, data) {
		console.error("Error encountered on action: ", type);
		console.error("ERROR: ", data);
		console.trace();
		dispatch({
			type: EventDispatcher.errorAction(type),
			data: {
				error: new Error(data)
			}
		});
	}

	static fatal(dispatch, type, data) {
		console.error("Fatal error encountered on action: ", type);
		console.error("FATAL: ", data);
		console.trace();
		dispatch({
			type: EventDispatcher.fatalAction(type),
			data: {
				error: new Error(data)
			}
		});
	}
}



// WEBPACK FOOTER //
// ./src/opencell/framework/EventDispatcher.js